const GENERIC_ERROR = "Something went wrong. Please try again, or email us at connect@ngineroom.ai.";
const MESSAGES = {
  INVALID_EMAIL: "That email address doesn't look valid.",
  RATE_LIMITED: "Too many attempts from your network. Please try again in an hour, or email us at connect@ngineroom.ai.",
};

export function buildSubmission(values, context) {
  return {
    name: values.name,
    email: values.email,
    company: values.company,
    vertical: values.vertical || "",
    page: context.page || "",
    website: values.website || "",
  };
}

export async function submitWaitlist(values, { apiUrl, fetch = globalThis.fetch, context = {} }) {
  if (!apiUrl) {
    throw new Error(GENERIC_ERROR, { cause: new Error("WAITLIST_API_URL is not configured.") });
  }
  const url = `${apiUrl.replace(/\/$/, "")}/waitlist`;
  let res;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(buildSubmission(values, context)),
    });
  } catch (err) {
    throw new Error(GENERIC_ERROR, { cause: err });
  }
  if (res.ok) return;
  const body = await res.json().catch(() => null);
  const code = body && body.error;
  throw new Error(MESSAGES[code] || GENERIC_ERROR, { cause: { status: res.status, body } });
}
